export const Bio = {
  name: "Nijgururaj Ashtagi",
  roles: [
    "ML Engineer",
    "Data Scientist",
    "Data Engineer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/nijgururajofficial",
  resume:
    "https://drive.google.com/file/d/1A_hOXDs0duetvbzyjC7AWGrQbM_F80L0/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/nijgururaj15/",
  phone: "+1 (xxx)xxx-xxxx",
  location: "Chicago, IL",
  email: "nijgururaja12@gmail.com",
};

export const skills = [
  {
    title: "Languages/Databases",
    skills: [
      {
        name: "Python",
        image:
          "https://s3.dualstack.us-east-2.amazonaws.com/pythondotorg-assets/media/community/logos/python-logo-only.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "MS SQL Server",
        image:
          "https://logowik.com/content/uploads/images/microsoft-sql-server4529.jpg",
      },
    ],
  },
  {
    title: "Libraries",
    skills: [
      {
        name: "Pandas",
        image:
          "https://logowik.com/content/uploads/images/pandas8580.logowik.com.webp",
      },
      {
        name: "NumPy",
        image:
          "https://logowik.com/content/uploads/images/numpy9166.logowik.com.webp",
      },
      {
        name: "Scikit-Lean",
        image:
          "https://quintagroup.com/cms/python/images/scikit-learn-logo.png/@@images/image.png",
      },
      {
        name: "Matplotlib",
        image: "https://matplotlib.org/stable/_images/sphx_glr_logos2_001.png",
      },
      {
        name: "PySpark",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Apache_Spark_logo.svg/1280px-Apache_Spark_logo.svg.png",
      },
      {
        name: "Seaborn",
        image: "https://cdn.worldvectorlogo.com/logos/seaborn-1.svg",
      },
      {
        name: "Tensorflow",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgLMZvZAhIoAosn4hKXIHakTEPv-XYvZiWIw&s",
      },
      {
        name: "OpenAI",
        image:
          "https://freelogopng.com/images/all_img/1681038887chatgpt-logo%20black-and-white.png",
      },
      {
        name: "LangChain",
        image:
          "https://python.langchain.com/img/brand/wordmark.png",
      },
      {
        name: "LangGraph",
        image:
          "https://python.langchain.com/img/brand/wordmark.png",
      }
      
    ],
  },
  {
    title: "Frameworks",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "JQuery",
        image: "https://cdn.worldvectorlogo.com/logos/jquery-4.svg",
      },
      {
        name: "Django",
        image:
          "https://w7.pngwing.com/pngs/119/322/png-transparent-django-logo-django-project-web-framework-web-development.png",
      },
      {
        name: "Flask",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmD38KsMgEwahtWc_Nfs5ZVktP9dBc36MUZA&s",
      },
    ],
  },
  {
    title: "Cloud and Other",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "AWS",
        image:
          "https://banner2.cleanpng.com/20190418/qty/kisspng-amazon-web-services-logo-cloud-computing-amazon-co-logoaws-1-itnext-summit-1713897691932.webp",
      },
      {
        name: "Azure",
        image:
          "https://banner2.cleanpng.com/20180802/wxy/kisspng-microsoft-azure-cloud-computing-microsoft-corporat-pricing-insight-amp-analytics-microsoft-azure-5b62c6dd915251.7076960515332000935953.jpg",
      },
      {
        name: "Postman",
        image: "https://cdn.worldvectorlogo.com/logos/postman.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dsgyw8mz3/image/upload/v1751398502/Image_Editor_q2wniq.png",
    role: "AI & Infrastructure Engineer",
    company: "S3CURA Inc. (Start-up)",
    date: "Jan 2025 - Present",
    desc: "Developed scalable Video Analytics SaaS using AWS cloud services, Google Gemini, and AI Vision APIs for intelligent content extraction and automated evidence processing. Built 25+ APIs with AWS Gateway/Lambda/DynamoDB and implemented WebSocket APIs for real-time communication. Engineered high-performance async Python pipelines, containerized microservices with Docker/ECR, and automated VPN setup with Step Functions for secure Raspberry Pi edge deployments.",
    skills: [
      "Python",
      "Docker",
      "AWS Lambda, S3, EC2, API Gateway, DynamoDB, Step Functions",
      "Google Gemini",
      "Computer Vision",
      "OpenCV",
      "WebSocket APIs",
      "FastAPI",
      "Raspberry Pi",
      "MLOps"
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  }
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdMCmMWD29POr2uf6leX9tJMladFDcn0PrlA&s",
    school: "Illinois Institute of Technology, Chicago",
    date: "August 2024 - May 2026",
    desc: "I am currently pursuing my Master of Science in Computer Science at the Illinois Institute of Technology, Chicago. I have opted for coursework including Computer Networks, Machine Learning, Science of Programming. I will be taking part in various volunteer work, hackathons and other events while being at Illinois Tech",

    degree: "Master's of Science, Computer Science",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxU1XaFYw8gmYPIMGQdDX-8_nz_p-4Jbc60w&s",
    school: "Savitribai Phule Pune University, Pune, Maharashtra, India",
    date: "Dec 2020 -  May 2024",
    grade: "8.66/10 CGPA",
    desc: "I have earned my bachelor's degree from one of the most prestigious universities in India. Along with Bachelor's Degree in Computer Engineering, I have earned an honours degree in Data Science. I have earned credits in coursework including Data Structures, Algorithms, Computer Networks, Database Systems, Operating Systems, Data Science, Machine Learning and Deep Learning.",

    degree: "ISC(XII), Science with Computer",
  },
];

export const projects = [
  {
    id: 10,
    title: "Predictive Stock Market Analysis",
    date: "Aug 2025",
    description:
      "Designed a predictive trading model in Python by applying statistical analysis to 15+ engineered financial indicators, reaching 96.6% forecast accuracy. Simulated algorithmic trading strategies using Pandas backtesting to assess and validate model profitability. Compared and cross-validated 5 machine learning models in Python to determine the most effective algorithm for generating trading signals. Leveraged Random Forest feature selection to isolate the most predictive indicators, enhancing efficiency and interpretability.",
    tags: ["Python", "Pandas", "NumPy", "Scikit-learn", "Matplotlib", "Random Forest"],
  },
  {
    id: 11,
    title: "AI Resume Builder (SaaS Product)",
    date: "Aug 2025",
    description:
      "Architected a multi-agent workflow with LangGraph + Google Gemini Pro to create ATS-compliant, job-tailored resumes, improving resume-job match accuracy. Orchestrated specialized LangChain agents (scraping, parsing, content selection, formatting) to automate resume customization and minimize manual work. Integrated JWT authentication with Firebase/PostgreSQL to provide scalable user account management and secure data persistence. Streamlined asynchronous workflows and containerized services with Docker to achieve low-latency API responses and production-grade scalability.",
    tags: ["Python", "FastAPI", "LangGraph", "LangChain", "Google Gemini", "Firebase"],
  },
  {
    id: 5,
    title: "Azure Databricks Real-Time ETL Pipeline",
    date: "Apr 2025",
    description:
      "Implemented a real-time data processing pipeline using Azure Databricks with Spark Streaming and Autoloader. Leveraged Delta Live Tables (DLT) for declarative ETL, and enforced data quality with SCD handling. Modeled data using a star schema design to optimize downstream analytics and reporting. Orchestrated end-to-end workflows using Databricks Workflows to automate processing of streaming files.",
    tags: ["Python", "Spark Streaming", "Azure Databricks", "Delta Live Tables", "SQL"],
  },
  {
    id: 1,
    title: "AI Powered Interview Bot",
    date: "Feb 2025",
    description:
    "Developed an AI-powered Interview Simulator using OpenAI's GPT-3.5 and Streamlit to automate the technical interview process, from resume screening to final job offer. Designed a multi-stage evaluation system with automated scoring for technical, DSA, and behavioral assessments, featuring real-time response analysis. Implemented a chatbot-style interface that adapts dynamically based on candidate performance, along with a resume-matching algorithm for precise candidate-role fit assessment.",
    image:
    "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "Python",
      "OpenAI",
    ],
    github: "https://github.com/nijgururajofficial/ai-powered-interview-bot",
  },
  {
    id: 6,
    title: "Uber Ride ETL & Demand Forecasting",
    date: "Jan 2025",
    description:
      "Built a robust ETL pipeline on Google Cloud, automating data ingestion, cleaning, and transformation of Uber ride datasets using SQL and Pandas. Executed exploratory data analysis (EDA) to uncover patterns in ride demand by time, location, and weather. Applied time-series models to forecast demand, aiding strategic decisions on fleet deployment. Designed an interactive dashboard on Looker Studio for real-time demand insights using BigQuery-sourced data.",
    tags: ["SQL", "Google Cloud", "BigQuery", "Pandas", "Matplotlib"],
  },
  {
    id: 0,
    title: "Data Migration from On-Premise to Azure Cloud",
    date: "Sept, 2024",
    description:
      "Engineered a full-scale cloud migration solution for an on-premise MS SQL Server database using Azure services. Automated data ingestion workflows using Azure Data Factory and stored raw data in Azure Blob Storage for scalable access. Implemented data transformation pipelines in Azure Databricks with parallelized Spark jobs to streamline processing. Integrated data into Azure SQL Data Warehouse and enabled real-time reporting via Power BI and Azure Analysis Services.",
    tags: [
      "Azure Data Factory",
      "Azure Databricks",
      "MS SQL Server",
      "Power BI",
    ],
  },
  {
    id: 2,
    title: "Image Caption Generator using Deep Learning",
    date: "Mar 2024",
    description:
      "I designed an Enhanced Image Caption Generator using deep learning, integrating CNNs for feature extraction and LSTM-based RNNs for sequence generation. The system generated over 1,000 contextually relevant captions, enhancing user engagement and improving visual content comprehension across applications. My research on this project was accepted by the International Conference on Data Science and Applications (ICDSA) 2024.",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "LSTM"],
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
